import { useEffect, useRef } from 'react';
import IconifyIcon from '../../../../components/wrappers/IconifyIcon';
import { useLayoutContext } from '../../../../context/useLayoutContext';
import { useLocation } from 'react-router-dom';

const LeftSideBarToggle = () => {
  const { menu: { size }, changeMenu: { size: changeMenuSize }, toggleBackdrop } = useLayoutContext();
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  const handleMenuSize = () => {
    if (size === 'hidden') toggleBackdrop();
    else if (size === 'condensed') changeMenuSize('sm-hover-active');
    else changeMenuSize('condensed');
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else if (size === 'hidden') {
      toggleBackdrop();
    }
  }, [pathname, size, toggleBackdrop]);

  return (
    <div className="topbar-item">
      <button type="button" className="button-toggle-menu" onClick={handleMenuSize} aria-label="Toggle sidebar" />
    </div>
  );
};

export default LeftSideBarToggle;
